export enum ZIndex {
    PasswordFieldIcon= 2,
    StickyHeaders = 5,
    MainHeader = 8,
    DropDownPopper = 1000,
    Tooltip = 2000,
    LoadingIndicator = 30000
}
